import { FC, useEffect, useState } from 'react'
import { crmApi } from '@/api'
import { Lead, LeadHistory } from '@/api/types/crm.types'
import { isError } from '@/helpers/checkQuery'
import { useAddAlert } from '@/hooks/useAddAlert'
import Preloader from '@UI/Preloader'
import cn from 'classnames'
import classes from './index.module.css'
import HistoryItem from './HistoryItem'
import usePagination from '@/hooks/usePagination'
import Pagination from '@UI/New/Pagination'
import Button from '@UI/New/Button'
import { ReloadOutlined, LoadingOutlined } from '@ant-design/icons'
import { Empty } from 'antd'

interface HistoryListBlockProps {
  lead: Lead
}

const HistoryListBlock: FC<HistoryListBlockProps> = ({ lead }) => {
  const addAlert = useAddAlert()

  const {
    state: dirtyData,
    loading,
    getState: refetchQuery,
    setState,
    ...paginationParams
  } = usePagination({
    api: crmApi.getLeadHistory,
    params: {
      lead_id: lead.id,
    },
  })

  const data = (dirtyData ?? []) as LeadHistory[]

  return (
    <>
      <div className={cn('custom-scroll', classes.list)}>
        {loading ? (
          <div className={classes.preloaderWrapper}>
            <Preloader fullScreen="app" />
          </div>
        ) : data.length < 1 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={'Ничего не найдено'}
            className={classes.emptyListItem}
          />
        ) : (
          data.map((item) => <HistoryItem key={item.id} historyItem={item} />)
        )}
      </div>
      <div className={classes.paginationWrapper}>
        <Pagination {...paginationParams} />
        <Button
          color="white"
          style={{ position: 'relative' }}
          onClick={() => refetchQuery()}
          disabled={loading}
          leftContent={
            loading ? (
              <LoadingOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            ) : (
              <ReloadOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            )
          }
        >
          Обновить
        </Button>
      </div>
    </>
  )
}

export default HistoryListBlock
